import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'S.M',
      text: 'Ich habe in wenigen Wochen mehr gelernt als in Monaten zuvor. Klarer Aufbau, direkte Anwendung – genau das hat mir gefehlt.',
      course: 'Level 2',
    },
    {
      name: 'S.T',
      text: 'Man fühlt sich nicht wie in einem Kurs, sondern wie in einer kleinen Gruppe, die gemeinsam vorankommt. Das motiviert extrem.',
      course: 'Level 2',
    },
    {
      name: 'R.B',
      text: 'Der Unterricht ist strukturiert und verständlich. Man merkt schnell Fortschritte und bleibt automatisch dran.',
      course: 'Level 1',
    },
    {
      name: 'A.S',
      text: 'Die Aufzeichnungen sind ein Gamechanger. Ich kann alles in meinem Tempo wiederholen und wirklich verstehen.',
      course: 'Level 2',
    },
    {
      name: 'N.A',
      text: 'Endlich ein Kurs, der nicht nur Inhalte zeigt, sondern einen wirklich Schritt für Schritt führt.',
      course: 'Level 2',
    },
    {
      name: 'R.Z',
      text: 'Sehr klar, sehr angenehm und extrem effektiv. Man merkt sofort, dass hier Erfahrung dahinter steckt.',
      course: 'Level 2',
    },
  ];

  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const visibleCount = isMobile ? 1 : 3;
  const visible = Array.from({ length: visibleCount }, (_, i) =>
    testimonials[(currentIndex + i) % testimonials.length]
  );

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
          <div className="max-w-xl">
            <p className="text-xs font-semibold tracking-[0.12em] uppercase text-[#970000] mb-3">
              Bewertungen
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-[-0.04em] leading-[1.1] text-gray-900">
              Was unsere{' '}
              <span className="oblique font-extrabold text-[#970000]">Arabisch-Schüler sagen</span>.
            </h2>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {visible.map((t, i) => (
            <div
              key={`${t.name}-${currentIndex}-${i}`}
              className="rounded-xl border border-gray-100 bg-white p-5 hover:border-[#970000]/30 transition-all duration-200"
            >
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} className="h-3.5 w-3.5 text-[#970000] fill-current" />
                ))}
              </div>
              <p className="text-[14px] text-gray-600 leading-relaxed mb-5">
                „{t.text}"
              </p>
              <div className="flex items-center justify-between">
                <p className="text-[13px] font-semibold text-gray-900">{t.name}</p>
                <span className="text-[11px] font-medium text-[#970000] bg-[#970000]/[0.07] px-2 py-0.5 rounded-full">
                  {t.course}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Dots + arrows */}
        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={prev}
            className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 hover:border-gray-300 transition-all"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <div className="flex items-center gap-1.5">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`h-1 rounded-full transition-all duration-300 ${
                  i === currentIndex ? 'w-6 bg-[#970000]' : 'w-3 bg-gray-200'
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 hover:border-gray-300 transition-all"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
